import styled from "styled-components";
import { FormControlLabel, Switch } from "@material-ui/core";
import { green, grey } from "@material-ui/core/colors";

export const STFormControlLabel = styled(FormControlLabel)`
  &&& {
    margin: 0;
  }
`;

export const STSwitch = styled(Switch).attrs({
  classes: {
    switchBase: "switchBase",
    track: "track",
    checked: "checked",
  },
})`
  &&& {
    .switchBase {
      color: ${grey[500]};
    }

    .checked {
      color: ${green[500]};
    }

    .track {
      background-color: ${grey[500]};
    }

    .checked + .track {
      background-color: ${green[500]};
    }
  }
`;
